function adaFocusAddHelper() {
  document.addEventListener('keydown', e => {
    if (e.keyCode === 9) {
      document.body.classList.add('show-focus');
    }
  });

  document.addEventListener('click', e => {
    /* onClick event on element produces a mouse event even when using the enter key.
    event.detail keeps track of the button clicks and will return 0 when the enter key
    is used. It will return a positive value on all other mouse events */
    if (e.detail) {
      document.body.classList.remove('show-focus');
    }
  });
}

export default adaFocusAddHelper;
